import request from '@/utils/request'



/**
 * 获取商家优惠券列表
 * @param {Object} data
 */
export function storeCouponList(data) {

	return request({
		url: `/api/user/coupon/collectable`,
		method: "get",
		params:data
	});
}

/**
 * 用户是否有未领取的优惠券
 * @param {Object} data
 */
export function hasRecAllCoupon(data) {

	return request({
		url: `/api/user/coupon/has`,
		method: "get",
		params:data
	});
}

/**
 * 用户领取优惠券
 * @param {Object} data
 */
export function receive(data) {

	return request({
		url: `/api/user/coupon/receive`,
		method: "post",
		data
	});
}

/**
 * 获取用户优惠券列表
 * @param {Object} data
 */
export function myCouponList(data) {

	return request({
		url: `/api/user/coupon/list`,
		method: "get",
		params:data
	});
}

/**
 * 获取订单可使用优惠券列表
 * @param {Object} data
 */
export function chooseCouponList(data) {

	return request({
		url: `/api/user/coupon/choose`,
		method: "get",
		params:data
	});
}